import React from 'react';

import { Wrapper } from './styles';
import NewHeart from '@spa/shared/svg/new-heart';

const AddToWishListSkeleton = () => (
  <Wrapper>
    <NewHeart className="wishlist-button" />
  </Wrapper>
);

export default AddToWishListSkeleton;
